// Hooks das ideias da semana.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { IdeaDraftResponse, IdeaDto, IdeasGenerateResponse, IdeasResponse } from '@impulso/shared/api/ai'
import { api } from '../../lib/api'
import { aiKeys } from '../ai/api'

export const ideasKeys = { list: (companyId: string) => ['ideas', companyId] as const }

export function useIdeas(companyId: string) {
  return useQuery({ queryKey: ideasKeys.list(companyId), queryFn: () => api.get<IdeasResponse>(`/companies/${companyId}/ideas`) })
}

export function useGenerateIdeas(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post<IdeasGenerateResponse>(`/companies/${companyId}/ideas/generate`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ideasKeys.list(companyId) })
      qc.invalidateQueries({ queryKey: aiKeys.usage(companyId) })
    },
  })
}

export function useIdeaFeedback(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (v: { id: string; reason: string }) => api.post<{ item: IdeaDto }>(`/companies/${companyId}/ideas/${v.id}/feedback`, { reason: v.reason }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ideasKeys.list(companyId) }),
  })
}

export function useIdeaDraft(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.post<IdeaDraftResponse>(`/companies/${companyId}/ideas/${id}/draft`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ideasKeys.list(companyId) }),
  })
}
